// в сумме не должно быть больше 100

const WIDTH_ID_COL = 11;
const WIDTH_ORDER_COL = 8;
const WIDTH_STATUS_COL = 7;
const WIDTH_INFO_COL = 8;
const WIDTH_LOADING_COL = 25;
const WIDTH_UNLOADING_COL = 25;
const WIDTH_CLIENT_COL = 11;

type ColTypes = 'id' | 'order' | 'status' | 'info' | 'loading' | 'unloading' | 'client';

export const getWidthCalculator = (withoutOrder: boolean, withoutClient: boolean) => {
  let additionalTotalWidth = 0;
  let columnWithWidth = 7;

  if (withoutOrder) {
    additionalTotalWidth = additionalTotalWidth + WIDTH_ORDER_COL;
    --columnWithWidth;
  }
  if (withoutClient) {
    additionalTotalWidth = additionalTotalWidth + WIDTH_CLIENT_COL;
    --columnWithWidth;
  }

  const additionalWidth = additionalTotalWidth / columnWithWidth;

  return (type: ColTypes) => {
    switch (type) {
      case 'id':
        return `${WIDTH_ID_COL + additionalWidth}%`;
      case 'order':
        return `${WIDTH_ORDER_COL + additionalWidth}%`;
      case 'status':
        return `${WIDTH_STATUS_COL + additionalWidth}%`;
      case 'info':
        return `${WIDTH_INFO_COL + additionalWidth}%`;
      case 'loading':
        return `${WIDTH_LOADING_COL + additionalWidth}%`;
      case 'unloading':
        return `${WIDTH_UNLOADING_COL + additionalWidth}%`;
      case 'client':
        return `${WIDTH_CLIENT_COL + additionalWidth}%`;
    }
  };
};
